import script from "./UploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadModal.vue?vue&type=style&index=0&id=6200e78a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6200e78a"]])

export default __exports__